import React from "react"; // useState, // useEffect,

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

interface RestrictionProps {
  open: boolean;
}
const loginRestriction: React.FC<RestrictionProps> = ({ open }) => {
  const navigate = useNavigate();
  const handleConfirmNo = () => {
    Cookies.remove("userToken");
    const authChannel = new BroadcastChannel("auth");
    authChannel.postMessage("logout");
    localStorage.removeItem("userToken"); // If stored in localStorage
    sessionStorage.removeItem("userToken"); // If stored in sessionStorage
    localStorage.removeItem("currentAnimId"); // If stored in sessionStorage
    localStorage.removeItem("currentSystemId"); // If stored in sessionStorage
    localStorage.removeItem("firstName"); // If stored in sessionStorage
    localStorage.removeItem("lastName"); // If stored in sessionStorage
    localStorage.removeItem("lng"); // If stored in sessionStorage
    localStorage.removeItem("selectedAnimationId");
    localStorage.removeItem("selectedSystemId");
    navigate("/logout");
  };
  const handleConfirmYes = () => {
    Cookies.remove("userToken");
    const authChannel = new BroadcastChannel("auth");
    authChannel.postMessage("logout");
    // Clear authentication data
    localStorage.removeItem("userToken"); // If stored in localStorage
    sessionStorage.removeItem("userToken"); // If stored in sessionStorage
    localStorage.removeItem("currentAnimId"); // If stored in sessionStorage
    localStorage.removeItem("currentSystemId"); // If stored in sessionStorage
    localStorage.removeItem("firstName"); // If stored in sessionStorage
    localStorage.removeItem("lastName"); // If stored in sessionStorage
    localStorage.removeItem("lng"); // If stored in sessionStorage
    localStorage.removeItem("selectedAnimationId");
    localStorage.removeItem("selectedSystemId");
    navigate("/logout");
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{ textAlign: "center", fontWeight: 600, color: "#d32f2f" }}
      >
        This session is no longer active
      </DialogTitle>

      <DialogContent>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "17px",
            lineHeight: "24px",
            color: "gray",
            px: 2,
          }}
        >
          Your account was accessed from another device. You have been logged
          out. If this wasn’t you, please log in again to regain access.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          <Button
            sx={{
              height: "45px",
              fontSize: "16px",
              borderRadius: "10px",
              textTransform: "none",
            }}
            onClick={handleConfirmYes}
            variant="contained"
            color="primary"
          >
            Continue to login page
          </Button>

          <Button
            sx={{
              height: "45px",
              fontSize: "16px",
              borderRadius: "10px",
              textTransform: "none",
            }}
            onClick={handleConfirmNo}
            variant="contained"
            color="primary"
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
export default loginRestriction;